import type { Form } from '../../../../common/types/form';
import type { Child } from '../../../../common/types/child';

const oldSchoolDataForm: Form<Child> = {
  key: 'oldSchoolData',
  title: 'Schule vor Frauenhaus',
  fields: [
    {
      key: 'typeOfOldSchool',
      label: 'Schulart',
      fieldTypes: 'select',
      options: [],
    },
    {
      key: 'oldSchoolClass',
      label: 'Klasse',
      fieldTypes: 'text',
    },
    {
      key: 'oldSchoolReligion',
      label: 'Religion',
      fieldTypes: 'select',
      options: [],
    },
    {
      key: 'oldSchoolAdress',
      label: 'Adresse',
      fieldTypes: 'text',
      xsWidth: 12,
    },
    {
      key: 'oldSchoolPhone',
      label: 'Telefon',
      fieldTypes: 'text',
    },
    {
      key: 'oldSchoolTeacher',
      label: 'Lehrkraft',
      fieldTypes: 'text',
    },
    {
      key: 'isExcusedOldSchool',
      label: 'Entschuldigt',
      fieldTypes: 'checkbox',
    },
    {
      key: 'oldSchoolExcusedNotice',
      label: 'Entschuldigt Notiz',
      fieldTypes: 'text',
    },
    {
      key: 'isDisenrolledOldSchool',
      label: 'abgemeldet',
      fieldTypes: 'checkbox',
    },
    {
      key: 'oldSchoolNotice',
      label: 'Notiz',
      fieldTypes: 'textArea',
      xsWidth: 12,
    },
  ],
};

export default oldSchoolDataForm;
